<template>
  <div class="row needs-padding-bottom">
    <div class="col-md-4 my-auto">
      <img class="round-image" src="https://picsum.photos/200">
    </div>
    <div class="col-md-8">
      <h5>{{ businessName }}</h5>
      <p>{{ services }}</p>
      <stars :rating="rating"></stars>
    </div>
  </div>
</template>

<script>
import stars from '../Stars.vue'
export default {
  components: {
    stars
  },
  props: {
    businessName: String,
    rating: Number,
    profilePic: String,
    services: String,
    businessId: String
  }
}
</script>

<style scoped>
.round-image {
  border-radius: 50%;
}

.fa-star {
  color: orange;
}

</style>



// WEBPACK FOOTER //
// src/components/business/rightSide/OtherViews.vue